import { baseUrl } from "../../../config.js";
import i18n from "../../../functions/i18next";

export default {
  data() {
    return {
      transfer: {},
      user: this.$store.state.user,
      company: this.$store.state.company,
      gettingFiles: false,
    };
  },
  created() {
    this.transfer.filescount = 0;
  },
  beforeMount() {
    this.$axios
      .get(baseUrl + "/transfer?id=" + this.$route.params.transfer, {
        responseType: "json",
      })
      .then((response) => {
        this.transfer = response.data;
      })
      .catch((error) => {
        this.$router.push("/404");
      });
  },
  methods: {
    handleClickDownload(e) {
      const btn = e.currentTarget;

      //disable
      this.gettingFiles = true;

      //text
      btn.textContent = i18n.t("transfer.getting_you_files");
    },
  },
};
